//@ts-check
import React from "react";
import { ErrorMessage } from '@hookform/error-message';
import classes from './user.module.scss';


const FormTextInput = ({ as, label, name, errors,  registerFunc, defaultValue, type, ...props }) => {

    return (
        <div className="form-group">

            {props.readOnly && <>
                <div className="mb-2" >{label}</div>
                <div className="preserve-white alert alert-warning not-allowed">{defaultValue}</div>
                
                {/* needed to make the data validation etc work in react-form */}
                <input type="hidden" {...registerFunc(name)} defaultValue={defaultValue} />
            </>}

            {!props.readOnly && (<>
                <div className="mb-2" >{label}</div>
                {as === "textarea" ?
                    <textarea defaultValue={defaultValue} {...registerFunc(name)} className="form-control" {...props} /> :
                    <input defaultValue={defaultValue} {...registerFunc(name)} type={type} className={(errors[name] ? classes.errorInput : "") + " form-control"} {...props} />
                }

                <ErrorMessage as="div" errors={errors} name={name} className={classes.errorMess} />
            </>)
            }



        </div>
    );
};


export default FormTextInput;